<ion-content  class="coach-profile-wrap content">

    <ion-header class="transparent absolute">
        <app-header [backRoute]="['/coach/profiles']"></app-header>
    </ion-header>

    <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
    </div>
    <div class="shadow-container">
        <div class="coach-head-text my-color-blue">{{'__COACH_PROFILE__' | translate}}</div>

        <div class="info-container" *ngIf="coach">

            <div class="coach-desktop-profile-photo">
                <img *ngIf="coach.file === null" src="assets/img/user-blue.svg" />
                <img *ngIf="coach.file !== null" [src]="coach.file.url" />
            </div>
            <div class="coach-profile-header">
                <div class="coach-info">
                    <div class="coach-profile-photo">
                        <img *ngIf="coach.file === null" src="assets/img/user-blue.svg" />
                        <img *ngIf="coach.file !== null" [src]="coach.file.url" />
                    </div>
                    <div class="coach-description">
                        <div class="coach-name">{{coach.full_name}}</div>
                        <div class="coach-speciality">{{coach.job_title}}</div>
                    </div>
                </div>

                <div class="coach-calendar">
                    <div>{{'__COACH_PROFILE_BOOKING_TEXT__' | translate}}</div>
                    <a [routerLink]="['/coach/profile/'+template_coach_id+'/calendar']">
                        <img src="assets/img/coach-calendar.svg" />
                    </a>
                </div>
            </div>

            <div class="left-column">
                <div class="back-to-profiles" [routerLink]="['/coach/profiles']">
                    <img src="assets/img/back-blue.svg" alt="" />
                    <div class="text">{{'__COACH_PROFILE_BACK_TEXT__' | translate}}</div>
                </div>
                <div class="coach-groups" *ngIf="!!coach.groups && coach.groups.length">
                    <div class="coach-groups-title">{{'__COACH_PROFILE_TOPICS__' | translate}}</div>
<!--                    <div class="coach-groups-title">Coach Topics</div>-->
                    <div *ngFor="let group of coach.groups" class="text">
                        <a [routerLink]="['/coach/profile/'+template_coach_id+'/calendar']">{{group.name}}</a>
                    </div>
                </div>
            </div>

            <div class="coach-data" [innerHTML]="coach.description"></div>
        </div>

        <div class="info-container" *ngIf="!coach">
            <div class="coach-desktop-profile-photo">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="coach-profile-header">
                <div class="coach-info">
                    <div class="coach-profile-photo">
                        <ion-skeleton-text animated></ion-skeleton-text>
                    </div>
                    <div class="coach-description">
                        <div class="coach-name"><ion-skeleton-text animated></ion-skeleton-text></div>
                        <div class="coach-speciality"><ion-skeleton-text animated></ion-skeleton-text></div>
                    </div>
                </div>

                <div class="coach-calendar" *ngIf="coach">
                    <div>{{'__COACH_PROFILE_BOOKING_TEXT__' | translate}}</div>
                    <a [routerLink]="['/coach/profile/'+template_coach_id+'/calendar']">
                        <img src="assets/img/coach-calendar.svg" />
                    </a>
                </div>
                <div class="coach-calendar" *ngIf="!coach">
                    <ion-skeleton-text animated style="width: 8.5rem; height: 2rem;"></ion-skeleton-text>
                    <ion-skeleton-text animated style="width: 8.5rem; height: 8.5rem; border-radius: 100%; "></ion-skeleton-text>
                </div>
            </div>

            <div class="left-column">
                <div class="back-to-profiles" [routerLink]="['/coach/profiles']">
                    <img src="assets/img/back-blue.svg" alt="" />
                    <div class="text">{{'__COACH_PROFILE_BACK_TEXT__' | translate}}</div>
                </div>
            </div>

            <div class="coach-data">
                <ion-skeleton-text animated *ngFor="let i of [1,2,3]"></ion-skeleton-text>
            </div>
        </div>
    </div>

    <app-footer-logo></app-footer-logo>
</ion-content>
